import EVENTS from '@/utils/Constants/Events';
import ChangeConfigPopup from '@/kenwood/configurator/components/ChangeConfigPopup';
import GoToSummaryPopup from '@/kenwood/configurator/components/GoToSummaryPopup';
import { PopupContent } from '@/kenwood/configurator/components/PromoBanner';
import { useConfiguratorContext } from '@/kenwood/configurator/context';
import { goHome } from '@/utils/Common/Redirects';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import PriceCounter from './cart/PriceCounter';

const stepsData = [
  {
    id: 1,
    name: 'configurator:configurator.header.step1',
  },
  {
    id: 2,
    name: 'configurator:configurator.header.step2',
  },
  {
    id: 3,
    name: 'configurator:configurator.header.step3',
  },
];

const backArrowBranded = 'arrow-branded.svg';
const backArrowWhite = 'arrow-white.svg';

const generateSteps = (currentStep, t, history, isOwner, cartEntries) => {
  const stepLinks = stepsData.map(stepData => {
    const isActive = stepData.id === currentStep;
    const isPrevious = stepData.id < currentStep;

    const handleStepClick = () => {
      if (isPrevious) {
        if (
          !sessionStorage.getItem('saveForLaterCalled') &&
          stepData.id === 1 &&
          cartEntries.length > 0
        ) {
          DLG.EVE.emit(EVENTS.CONFIGURATOR.SAVE_FOR_LATER.OPEN_POPUP, {
            historyPushParam: `${DLG.config.encodedContextPath}/configurator/step1`,
          });
        } else if (stepData.id === 1) {
          history.push(`${DLG.config.encodedContextPath}/configurator/step1`);
        } else if (
          stepData.id === 2 &&
          cartEntries.length > 0 &&
          !sessionStorage.getItem('saveForLaterCalled')
        ) {
          DLG.EVE.emit(EVENTS.CONFIGURATOR.SAVE_FOR_LATER.OPEN_POPUP, {
            historyPushParam: `${DLG.config.encodedContextPath}/configurator/step2`,
          });
        } else if (stepData.id === 2) {
          history.push(`${DLG.config.encodedContextPath}/configurator/step2`);
        }
      }
    };

    return (
      <React.Fragment key={stepData.id}>
        <button
          type='button'
          className={`ken-configurator__header-step-link ${
            isActive ? '-active' : ''
          } ${isPrevious ? '-previous' : ''}`}
          onClick={handleStepClick}
        >
          {t(stepData.name)}
        </button>
        {stepData.id < stepsData.length && (
          <div className='ken-configurator__header-step-divisor' />
        )}
      </React.Fragment>
    );
  });

  return stepLinks;
};

const Header = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const [
    { currentStep, stepTwoMenuOpen, cartEntries, selectedConnection, isOwner },
    { setStepTwoMenuOpen, setChangeConfigOpen },
  ] = useConfiguratorContext();

  const steps = generateSteps(currentStep, t, history, isOwner, cartEntries);

  const [popupIsOpen, setPopupIsOpen] = useState(false);
  const [promoPopupOpen, setPromoPopupOpen] = useState(false);
  const [backHovered, setBackHovered] = useState(false);
  const [accessoriesInCart, setAccessoriesInCart] = useState(0);
  const [step3Enabled, setStep3Enabled] = useState(false);
  const [
    goToSummaryPupupToBeDisplay,
    setGoToSummaryPupupToBeDisplay,
  ] = useState(true);

  useEffect(() => {
    let accessoriesQuantity = cartEntries.reduce(
      (acc, item) => acc + item.quantity,
      0,
    );

    if (selectedConnection) {
      accessoriesQuantity += 1;
    }

    setAccessoriesInCart(accessoriesQuantity);

    if (isOwner) {
      setStep3Enabled(accessoriesQuantity > 0);
    } else {
      setStep3Enabled(true);
    }
  }, [cartEntries, selectedConnection]);

  return (
    <header className='ken-configurator__header'>
      <div className='ken-configurator__header-wrapper'>
        <div className='ken-configurator__header-wrapper-inner'>
          <button
            className='ken-configurator__header-exit'
            type='button'
            onClick={() => {
              if (currentStep === 1) {
                goHome();
              } else if (
                currentStep === 3 &&
                cartEntries.length > 0 &&
                !sessionStorage.getItem('saveForLaterCalled')
              ) {
                DLG.EVE.emit(EVENTS.CONFIGURATOR.SAVE_FOR_LATER.OPEN_POPUP, {
                  changeConfigParam: 'header',
                  storefrontMessagesScenario: 2,
                });
              } else {
                setChangeConfigOpen('header');
              }
            }}
          >
            <img
              className='ken-configurator__header-exit-img'
              src={`${DLG.config.distResourcePath}/assets/images/kenwood/configurator/exit.svg`}
              alt={t('configurator:configurator.alt.exit')}
            />
          </button>
          <div className='ken-configurator__header-steps'>{steps}</div>
        </div>
        <ChangeConfigPopup />

        {currentStep === 2 && (
          <>
            <button
              type='button'
              onClick={() => setPromoPopupOpen(true)}
              className={`ken-configurator__header-discount-message ${
                stepTwoMenuOpen ? '-mobile-open' : ''
              }`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: t('configurator:configurator.header.promo.message'),
              }}
            />
            <div
              className={`ken-configurator__header-cart ${
                stepTwoMenuOpen ? '-mobile-open' : ''
              }`}
            >
              <div className='ken-configurator__header-cart-summary-wrapper'>
                <PriceCounter />
                <div className='ken-configurator__header-cart-summary'>
                  <img
                    className='ken-configurator__header-cart-img'
                    src={`${DLG.config.distResourcePath}/assets/images/kenwood/configurator/cart.svg`}
                    alt={t('configurator:configurator.alt.cart')}
                  />
                  <div className='ken-configurator__header-cart-label'>
                    <span>{t('configurator:configurator.header.added')}</span>
                    <span>
                      {t('configurator:configurator.header.accessories')}
                    </span>
                  </div>
                  <div
                    className={`ken-configurator__header-cart-quantity ${step3Enabled &&
                      '-active'}`}
                  >
                    <span>{accessoriesInCart}</span>
                  </div>
                </div>
              </div>
              <div className='ken-configurator__header-cart-ctas'>
                <button
                  type='button'
                  className='ken-button--secondary ken-configurator__header-cart-back'
                  onClick={() => setStepTwoMenuOpen(false)}
                  onMouseEnter={() => setBackHovered(true)}
                  onMouseLeave={() => setBackHovered(false)}
                >
                  <img
                    src={`${
                      DLG.config.distResourcePath
                    }/assets/images/kenwood/configurator/${
                      backHovered ? backArrowWhite : backArrowBranded
                    }`}
                    alt={t('configurator:configurator.alt.back')}
                    className='ken-configurator__header-cart-back-img'
                  />
                </button>
                <button
                  type='button'
                  onClick={() => {
                    if (step3Enabled) {
                      if (
                        ((isOwner && accessoriesInCart === 1) ||
                          (!isOwner && accessoriesInCart === 0) ||
                          (!isOwner && accessoriesInCart === 1)) &&
                        goToSummaryPupupToBeDisplay
                      ) {
                        setGoToSummaryPupupToBeDisplay(false);
                        setPopupIsOpen(true);
                      } else {
                        history.push(
                          `${DLG.config.encodedContextPath}/configurator/step3`,
                        );
                      }
                    }
                  }}
                  className={`ken-configurator__header-cart-link ${!step3Enabled &&
                    '-disabled'}`}
                  disabled={!step3Enabled}
                >
                  <span>
                    {t('configurator:configurator.header.goto')}&nbsp;
                  </span>
                  {t('configurator:configurator.header.summary')}
                </button>
              </div>
            </div>
            <PopupContent
              isOpen={promoPopupOpen}
              onClose={() => {
                setPromoPopupOpen(false);
              }}
            />
          </>
        )}
      </div>
      <div className='ken-configurator__header-cockpit'>
        <GoToSummaryPopup
          isOpen={popupIsOpen}
          setIsOpen={setPopupIsOpen}
          isOwner={isOwner}
        />
      </div>
      <div className='ken-configurator__header-progress'>
        <div
          className={`ken-configurator__header-progress-inner -w-${currentStep}`}
        />
      </div>
    </header>
  );
};

export default Header;
